import { Link } from "react-router-dom";
import { AuthShell, SsoButton } from "./Login";
import { Button, Mono, Pill } from "../components/v3";

/**
 * Signup — placeholder while multi-user backend (task #63) is deferred.
 *
 * Vooice currently runs single-tenant: there is one operator account, set
 * up via the existing admin password during install. New-user signup ships
 * once the users table + per-user data segregation lands.
 *
 * The page intentionally looks complete (form-shaped, branded) so the auth
 * surface doesn't feel broken — but submission is disabled with a clear
 * explanation rather than pretending to work.
 */
export function Signup() {
  return (
    <AuthShell
      title="Sign up"
      subtitle="One operator per Vooice instance. Multi-user is on the way."
    >
      <div className="space-y-4">
        <Pill tone="warn" className="mb-2">
          Single-tenant beta
        </Pill>

        <SsoButton provider="google" />

        <div className="flex items-center gap-3 py-1">
          <div className="flex-1 h-px bg-line" />
          <Mono className="px-1">or</Mono>
          <div className="flex-1 h-px bg-line" />
        </div>

        <div className="space-y-3">
          <FieldStub label="Email" placeholder="you@example.com" type="email" />
          <FieldStub
            label="Password"
            placeholder="Choose a password"
            type="password"
          />
        </div>

        <Button variant="amber" size="lg" disabled className="w-full">
          Create account · Coming soon
        </Button>

        <p className="text-t3 text-sm leading-relaxed pt-2 border-t border-line-soft">
          Vooice is currently single-operator. Per-user accounts with isolated
          contacts, calls, and memory are planned but not yet shipped. If you
          have an operator password,{" "}
          <Link to="/login" className="text-amber hover:underline">
            sign in here
          </Link>
          .
        </p>
      </div>
    </AuthShell>
  );
}

function FieldStub({
  label,
  placeholder,
  type,
}: {
  label: string;
  placeholder: string;
  type: string;
}) {
  return (
    <div>
      <label className="mono-caps block mb-2">{label}</label>
      <input
        type={type}
        placeholder={placeholder}
        disabled
        className="w-full px-4 py-3 bg-bg-2/50 border border-line rounded-md text-t1 placeholder:text-t4 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      />
    </div>
  );
}
